export const ADMIN_PANEL = 'Админ-панель';
export const ADMIN_ORDER = 'Заказ';

// sections
export const PROMO_SECTION = 'promo';
export const OPERATORS_SECTION = 'operators';
export const ORDERS_SECTION = 'orders';
export const USERS_SECTION = 'users';
export const SYSTEM_SECTION = 'system';

export const PROMO_TITLE = 'Промокоды';
export const OPERATORS_TITLE = 'Операторы';
export const ORDERS_TITLE = 'Заказы';
export const USERS_TITLE = 'Пользователи';
export const SYSTEM_TITLE = 'Системные';

// promo
export const NEW_PROMO = 'Новый промокод';
export const PROMO_CODE_PLACEHOLDER = 'Промокод';
export const PROMO_VALUE_PLACEHOLDER = 'Размер скидки, %';
export const PROMO_DAYS_PLACEHOLDER = 'Действует дней';
export const ADD = 'Добавить';
export const DELETE = 'Удалить';
export const PROMO_CODE = 'Код';
export const PROMO_DISCOUNT = 'Скидка, %';
export const PROMO_USAGE = 'Применен, раз';
export const PROMO_CREATION_DATE = 'Дата создания';
export const PROMO_ACTIVE_DAYS = 'Действует, дней';
export const NO_PROMO = 'Промокодов пока нет';
export const PROMO_ADDED = 'Промокод добавлен';
export const PROMO_EXISTS = 'Такой промокод уже есть';
export const PROMO_FILL_FIELDS = 'Укажите промокод и размер скидки';

// system
export const PAYMENT_TEST = 'Тестовый режим оплаты';
export const SELL_ON_STOP = 'Продажа туров на стопе';

// operators
export const SPLIT = 'Разбивка';
export const OPERATOR_SETTINGS = 'Общие настройки (для всех городов)';
export const DEPARTURE_SETTINGS = 'Настройки по городу вылета';
export const REGULAR_SPLIT = 'Разбивка, регулярные рейсы';
export const CHARTER_SPLIT = 'Разбивка, чартерные рейсы';
export const INSURANCE_AVAILABLE = 'Страховка доступна';
export const BEFORE = 'За';
export const DAYS = 'дней';
export const PERCENT = '%';
export const SUCCESSFULLY_UPDATED = 'Успешно обновлено';

// orders
export const ORDER_NUMBER = 'Номер';
export const ORDER_PRICE = 'Цена';
export const ORDER_CURRENCY = 'Валюта';
export const ORDER_STATUS = 'Статус';
export const NO_NEW_ORDERS = 'Нет новых заказов';
export const CREATE_ORDER = 'Создать заказ';
export const CREATE_ORDER_TITLE = 'Новый заказ';
export const ORDER_TOUR_ID_PLACEHOLDER = 'ID тура';
export const ORDER_EMAIL_PLACEHOLDER = 'Email клиента';
export const CREATE_ORDER_FILL_TOUR_ID = 'Укажите ID тура';
export const CREATE_ORDER_FILL_EMAIL = 'Укажите email клиента';
export const CREATE_ORDER_TOUR_NOT_FOUND = 'Тур не найден или уже недоступен';
export const ACTUALIZE = 'Актуализировать';
export const ADD_ORDER = 'Добавить заказ';
export const RETRY = 'Повторить';
export const FLIGHT_LOADING = 'Загружаем перелёт…';
export const FLIGHT_NOT_LOADED = 'Перелёт не загружен';
export const ORDER_WITHOUT_FLIGHT =
  'Заказ будет создан без данных о перелёте, цена — по туру';
export const ORDER_PREVIEW_FLIGHT = 'Перелёт';
export const ORDER_PREVIEW_TOURISTS = 'Туристы';
export const ORDER_PREVIEW_TOTAL = 'Итого';

// keys of the order built after actualization, labels from ORDER_FIELD_SECTIONS
export const ORDER_PREVIEW_SECTIONS = [
  {
    title: 'Тур',
    keys: [
      'operator',
      'countryTo',
      'resort',
      'departureCity',
      'departureDate',
      'nightsCount',
      'program',
    ],
  },
  {
    title: 'Отель',
    keys: [
      'hotelName',
      'hotelCategory',
      'roomType',
      'settlementType',
      'meal',
      'touristsText',
    ],
  },
];
export const ORDER_PREVIEW_PRICE = {
  title: 'Стоимость',
  keys: ['originalPrice', 'currency', 'totalPrice', 'splitPayment'],
};

// order stages (crm board)
export const STAGE_ORDER_CREATED = 'ORDER_CREATED';
export const STAGE_FUNDS_HOLD = 'FUNDS_HOLD';
export const STAGE_OPERATOR_REQUEST = 'OPERATOR_REQUEST';
export const STAGE_APPROVED = 'APPROVED';
export const STAGE_FUNDS_CHARGED = 'FUNDS_CHARGED';
export const STAGE_DOCUMENTS_SENT = 'DOCUMENTS_SENT';
export const STAGE_FLIGHT_CHECKED = 'FLIGHT_CHECKED';
export const STAGE_REMINDER_SENT = 'REMINDER_SENT';

export const REPLACE_TOUR_STAGES = [
  STAGE_ORDER_CREATED,
  STAGE_FUNDS_HOLD,
  STAGE_OPERATOR_REQUEST,
];

export const ORDER_STAGES = [
  { id: STAGE_ORDER_CREATED, title: 'Заказ создан', color: '#5DA9EB' },
  {
    id: STAGE_FUNDS_HOLD,
    title: 'Средства захолдированы',
    color: '#5FAFEA',
  },
  {
    id: STAGE_OPERATOR_REQUEST,
    title: 'Заявка оператору создана',
    color: '#62C2F0',
  },
  { id: STAGE_APPROVED, title: 'Подтвержден', color: '#76CEE0' },
  { id: STAGE_FUNDS_CHARGED, title: 'Средства списаны', color: '#76DFC0' },
  { id: STAGE_DOCUMENTS_SENT, title: 'Документы высланы', color: '#66CCFA' },
  { id: STAGE_FLIGHT_CHECKED, title: 'Вылет проверен', color: '#74CFDE' },
  { id: STAGE_REMINDER_SENT, title: 'Напоминание выслано', color: '#8BD44B' },
];

// status is what the customer sees, stage is the internal crm step
export const STATUS_PREFIX = 'Статус';
export const STAGE_PREFIX = 'Стадия';
export const STATUS_HINT = 'Статус заказа, который видит клиент';
export const STAGE_HINT = 'Внутренняя стадия обработки заказа (CRM)';

export const NO_ORDERS_IN_STAGE = 'Нет заказов';

// archive: the order stays in the db but leaves the board
export const BOARD_TAB = 'Доска';
export const ARCHIVE_TAB = 'Архив';
export const ARCHIVE_SEARCH_PLACEHOLDER = 'Поиск по номеру заказа';
export const ARCHIVE_NOT_FOUND = 'Заказ не найден';
export const TO_ARCHIVE = 'В архив';
export const TO_ARCHIVE_CONFIRM = 'Точно в архив?';
export const TO_ARCHIVE_HINT = 'Данные заказчика и туристов будут удалены';
export const ARCHIVED_PEOPLE_REMOVED =
  'Данные заказчика и туристов удалены при переносе в архив';
export const ARCHIVED_BADGE = 'В архиве';
export const NO_ARCHIVED_ORDERS = 'В архиве нет заказов';
export const NEXT_STAGE = 'Следующая стадия';
export const NEXT_STAGE_FUNDS_HOLD =
  'Средства захолдированы: клиенту уйдет письмо «Заказ оформлен»';
export const NEXT_STAGE_APPROVED =
  'Подтвержден: клиенту уйдет письмо о подтверждении заказа';
export const STAGE_EMAIL_CONFIRM = 'Клиенту уйдет письмо';
export const STAGE_CONFIRM_YES = 'Перевести';
export const STAGE_CONFIRM_NO = 'Отмена';

// order modal
export const ORDER_STAGE = 'Стадия';
export const EMPTY_VALUE = '—';
export const YES = 'Да';
export const NO = 'Нет';
export const ORDER_NUMBER_TITLE = 'Заказ №';
export const DELETE_CONFIRM = 'Точно удалить?';
// declining: only at the "operator request" stage
export const DECLINE_ORDER = 'Отклонить';
export const DECLINE_ORDER_CONFIRM = 'Точно отклонить?';
export const DECLINE_ORDER_HINT = 'Клиенту уйдет письмо, заказ уйдет в архив';
export const REPLACE_TOUR = 'Заменить тур';
export const REPLACE_TOUR_CONFIRM = 'Точно заменить?';
export const REPLACE_TOUR_CONFIRM_HINT =
  'Клиенту уйдет письмо об изменении заказа с новым туром';
export const REPLACE_TOUR_TITLE = 'Замена тура';
export const REPLACE_TOUR_HINT =
  'Туристы и данные заказчика останутся в заказе, новый тур — на тот же состав туристов. Заказ вернется в статус «Ожидает оплаты» и на стадию «Заказ создан», клиенту уйдет письмо с новым туром';
export const REPLACE_TOUR_TOURISTS_MISMATCH =
  'Состав туристов в новом туре отличается от заказа, заменить тур нельзя';
export const REPLACE_TOUR_WITHOUT_FLIGHT =
  'Тур будет заменен без данных о перелёте, цена — по туру';

export const ORDER_FIELD_SECTIONS = [
  {
    title: 'Тур',
    fields: [
      { key: 'operator', label: 'Оператор' },
      { key: 'tourId', label: 'ID тура' },
      { key: 'countryTo', label: 'Страна' },
      { key: 'resort', label: 'Курорт' },
      { key: 'program', label: 'Программа' },
      { key: 'departureCity', label: 'Город вылета' },
      { key: 'departureDate', label: 'Дата вылета' },
      { key: 'nightsCount', label: 'Ночей' },
    ],
  },
  {
    title: 'Отель',
    fields: [
      { key: 'hotelName', label: 'Отель' },
      { key: 'hotelCategory', label: 'Категория' },
      { key: 'hotelId', label: 'ID отеля' },
      { key: 'roomType', label: 'Номер' },
      { key: 'hotelPlaceName', label: 'Размещение' },
      { key: 'settlementType', label: 'Тип размещения' },
      { key: 'meal', label: 'Питание' },
      { key: 'hotelImage', label: 'Фото' },
    ],
  },
  {
    title: 'Перелёт',
    fields: [
      { key: 'toTrip', label: 'Туда' },
      { key: 'backTrip', label: 'Обратно' },
    ],
  },
  {
    title: 'Состав',
    fields: [
      { key: 'adultsCount', label: 'Взрослых' },
      { key: 'kidsCount', label: 'Детей' },
      // hideEmpty: not shown when there is no such child
      { key: 'childAge1', label: 'Возраст 1-го ребенка', hideEmpty: true },
      { key: 'childAge2', label: 'Возраст 2-го ребенка', hideEmpty: true },
      { key: 'childAge3', label: 'Возраст 3-го ребенка', hideEmpty: true },
    ],
  },
  {
    title: 'Стоимость и оплата',
    fields: [
      { key: 'originalPrice', label: 'Цена оператора' },
      { key: 'currency', label: 'Валюта' },
      { key: 'totalPriceByn', label: 'Итого, BYN' },
      { key: 'totalPriceAlfa', label: 'Сумма в Альфа' },
      { key: 'promoCode', label: 'Промокод' },
      { key: 'flightInsurance', label: 'Страховка от невылета' },
      { key: 'flightInsuranceValueByn', label: 'Страховка, BYN' },
      { key: 'split', label: 'Разбивка' },
      { key: 'splitPayment', label: 'Оплата частями' },
      { key: 'splitPaymentValue', label: 'Первый платеж' },
      { key: 'splitPaymentAlfa', label: 'Первый платеж в Альфа' },
    ],
  },
  {
    title: 'Контакты',
    fields: [
      { key: 'email', label: 'Email' },
      { key: 'phoneNumber', label: 'Телефон' },
      { key: 'userId', label: 'ID пользователя' },
      { key: 'note', label: 'Примечание' },
    ],
  },
  {
    title: 'Служебное',
    fields: [
      { key: 'id', label: 'ID' },
      { key: 'externalId', label: 'Номер заказа' },
    ],
  },
];

export const CONTACT_INFO_TITLE = 'Заказчик';
export const TOURIST_TITLE = 'Турист';

// buyer and tourists editing
export const PEOPLE_TITLE = 'Заказчик и туристы';
export const PERSON_EMPTY = 'Данные не заполнены';
export const EDIT = 'Редактировать';
export const SAVE = 'Сохранить';
export const CANCEL = 'Отмена';
export const SEX_NOT_SET = 'Не указан';

// another flight of the order tour
export const ORDER_FLIGHT_HINT =
  'Стоимость заказа пересчитается по актуальной цене тура с выбранным перелетом';
export const ORDER_FLIGHT_LOAD_ERROR =
  'Не удалось загрузить перелеты, тур мог стать недоступен';
export const ORDER_FLIGHT_NO_OTHER = 'Других перелетов для этого тура сейчас нет';

// type: 'date' | 'sex' | 'upper' (latin in capitals) | text by default
// the split payment and the alfa sums are counted from these fields
export const ORDER_PRICE_EDIT_FIELDS = [
  { key: 'originalPrice', label: 'Цена оператора', type: 'number' },
  {
    key: 'currency',
    label: 'Валюта',
    type: 'select',
    options: ['USD', 'EUR', 'BYN', 'RUB'].map((item) => ({
      value: item,
      label: item,
    })),
  },
  { key: 'totalPriceByn', label: 'Итого, BYN', type: 'number' },
  {
    key: 'flightInsurance',
    label: 'Страховка от невылета',
    type: 'select',
    options: [
      { value: 'true', label: YES },
      { value: 'false', label: NO },
    ],
  },
  { key: 'flightInsuranceValueByn', label: 'Страховка, BYN', type: 'number' },
  { key: 'split', label: 'Разбивка, %', type: 'number' },
];
export const ORDER_PRICE_INVALID =
  'Укажите итоговую сумму и разбивку от 1 до 100%';
export const BYN_CURRENCY = 'BYN';

export const ORDER_CONTACTS_EDIT_FIELDS = [
  { key: 'email', label: 'Email' },
  { key: 'phoneNumber', label: 'Телефон' },
  { key: 'note', label: 'Примечание' },
];

export const CONTACT_EDIT_FIELDS = [
  { key: 'lastName', label: 'Фамилия' },
  { key: 'firstName', label: 'Имя' },
  { key: 'afterName', label: 'Отчество' },
  { key: 'birthDay', label: 'Дата рождения', type: 'date' },
  { key: 'sex', label: 'Пол', type: 'sex' },
  { key: 'passport', label: 'Паспорт' },
  { key: 'passportStartDate', label: 'Паспорт выдан', type: 'date' },
  { key: 'passportEndDate', label: 'Паспорт действует до', type: 'date' },
  { key: 'postIndex', label: 'Индекс' },
  { key: 'city', label: 'Населенный пункт' },
  { key: 'street', label: 'Улица' },
  { key: 'house', label: 'Дом' },
  { key: 'flat', label: 'Квартира' },
];

export const TOURIST_EDIT_FIELDS = [
  { key: 'lastNameUpper', label: 'Фамилия (лат.)', type: 'upper' },
  { key: 'firstNameUpper', label: 'Имя (лат.)', type: 'upper' },
  { key: 'birthDay', label: 'Дата рождения', type: 'date' },
  { key: 'sex', label: 'Пол', type: 'sex' },
  { key: 'citizenship', label: 'Гражданство' },
  { key: 'passport', label: 'Паспорт' },
  { key: 'passportStartDate', label: 'Паспорт выдан', type: 'date' },
  { key: 'passportEndDate', label: 'Паспорт действует до', type: 'date' },
  { key: 'identity', label: 'Личный номер' },
];

// users
export const USERS_SEARCH_PLACEHOLDER = 'Поиск по email';
export const USERS_TOTAL = 'Всего';
export const USER_EMAIL = 'Email';
export const USER_REGISTRATION_DATE = 'Дата регистрации';
export const USER_EMAIL_VERIFIED = 'Email подтвержден';
export const USER_HAS_PASSWORD = 'Пароль задан';
export const USER_ROLES = 'Роли';
export const NO_USERS = 'Пользователей не найдено';

export const USER_ROLE_TITLES = {
  ROLE_ADMIN: 'Админ',
  ROLE_MODERATOR: 'Модератор',
  ROLE_USER: 'Пользователь',
};
export const USER_DETAILS_TITLE = 'Информация';
export const USER_ORDERS_TITLE = 'Заказы';
export const USER_ID = 'ID';
export const NO_USER_ORDERS = 'Заказов нет';
export const DELETE_USER = 'Удалить пользователя';
export const DELETE_USER_CONFIRM = 'Точно удалить?';
export const DELETE_USER_HINT =
  'Пользователь будет удален вместе со всеми заказами, без возможности восстановления';
export const DELETE_USER_ORDERS = 'Будет удалено заказов';
export const DELETE_USER_SELF = 'Нельзя удалить свою учетную запись';
